import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import AreaValidations from 'scaleflow/validators/area';

export default class AreasFormComponent extends Component {
  AreaValidations = AreaValidations;
  @tracked changeset;

  @action
  async submitForm(changeset, event) {
    event.preventDefault();

    const isValid = await changeset.validate();

    if (isValid) {
      // Apply changes to the model
      await changeset.save();

      // Call the parent's onSave action
      if (this.args.onSave) {
        await this.args.onSave(this.args.area);
      }
    }
  }

  @action
  handleBlur(changeset) {
    // This is for the Atoms::Forms::Input component
    changeset.validate();
  }

  get isEdit() {
    return !!this.args.area?.id;
  }

  @action
  cancelForm(changeset) {
    changeset.rollback();
    if (this.args.onCancel) {
      this.args.onCancel();
    }
  }
}
